import Vue from 'vue/dist/vue.esm'

Vue.component(
  "sofia-file-uploader-vue",
  () => import(/* webpackChunkName: "[request]" */ "components/sofia/FileUploader")
)